import { render } from "./merge_table_component.vue?vue&type=template&id=5fcb963c"
import script from "./merge_table_component.vue?vue&type=script&lang=js"
export * from "./merge_table_component.vue?vue&type=script&lang=js"

import "./merge_table_component.vue?vue&type=style&index=0&id=5fcb963c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__